<template>
  <v-card>
    <v-card-title primary-title>
      <div>
        <div class="headline">Error</div>
        <span class="grey--text">An error occurred when saving your claim</span>
      </div>
    </v-card-title>
    <v-card-text>
      <div v-if="saveErrors.messages.length > 0" class="pb-3">
        <v-subheader>General Error</v-subheader>
        <ul class="claimErrorMsgs">
          <li v-for="(error, index) in saveErrors.messages" :key="index">
            {{error}}
          </li>
        </ul>
      </div>
      <div v-if="saveErrors.fieldMessages.length > 0" class="pb-3">
        <v-subheader>Field Specific Error</v-subheader>
        <ul class="claimErrorMsgs">
          <li v-for="(error, index) in saveErrors.fieldMessages" :key="index">
            {{error}}
          </li>
        </ul>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="red darken-1" flat="flat" @click.native="doClose">Close</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  computed: {
    saveErrors() {
      return this.$store.state.claims.claimDetail.saveError
    }
  },
  methods: {
    doClose() {
      // revert the state
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
.claimErrorMsgs {
  padding-left: 15px;
}
</style>
